module.exports = __webpack_public_path__ + "img/lfb_home_pres.be82274b.jpg";